import React from 'react';
import BaseScadaNode from './BaseScadaNode';

export default function ImageEmbedNode(props) {
    const { data } = props;
    const config = data?.config || {};
    return (
        <BaseScadaNode {...props}>
            <div style={{ width: '100%', height: '100%', overflow: 'hidden', borderRadius: config.border_radius || 0 }}>
                {config.src
                    ? <img src={config.src} alt={data?.label || ''} style={{ width: '100%', height: '100%', objectFit: config.object_fit || 'contain' }} />
                    : <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#475569', fontSize: 11, border: '1px dashed #334155' }}>No image</div>
                }
            </div>
        </BaseScadaNode>
    );
}
